module.exports = __webpack_public_path__ + "img/icon-fb-mr.d5c86c24.svg";